import React, { useEffect, useState, useContext } from "react";
import { json, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
// import { SocketContext } from "../SocketContext"; // adjust path if needed
import iziToast from "izitoast";

const Navbar = ({ page }) => {
    // const { socket, connectSocket } = useContext(SocketContext);
    const navigate = useNavigate();
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const { logout } = useAuth();
    const userData = JSON.parse(localStorage.getItem('userData'));
    // console.log(userData);
    const token = localStorage.getItem('token');
    const usertype = localStorage.getItem('userType');
    const username = userData ? userData.name : "";

    // console.log(usertype);
    // useEffect(() => {
    //     if (usertype === 'user') {
    //         if (socket) {
    //             socket.emit('loggedin', { 'token': token, 'room': 'exam1' });
    //             socket.on("status", (msg) => {
    //                 console.log(msg);
    //                 console.log("Connected to:", msg.room);
    //             });

    //             socket.on("disconnect", () => {
    //                 iziToast.warning({ message: "Disconnected", position: "topCenter" });
    //             });
    //         }
    //         else {
    //             connectSocket(token);
    //         }
    //     }
    //     if (usertype === 'super_admin') {
    //         if (socket) {
    //             console.log("socket connection found");
    //             socket.emit("superadmin", { token: token, room: "admin-room" });
    //             // socket.emit("getRoomStats", { room: "exam1" });

    //             socket.on("roomStats", (data) => {
    //                 console.log("Room stats:", data);
    //             });
    //         }
    //         else {
    //             connectSocket(token);
    //         }
    //     }
    // }, [socket]);

    // Toggle dropdown visibility
    const showDropdown = () => {
        setDropdownVisible(true);
    };

    // Hide dropdown on mouse leave
    const hideDropdown = () => {
        setDropdownVisible(false);
    };
    const goHome = () => {
        if (usertype !== 'user') {
            navigate('/dashboard');
        }
    }
    return (
        <>
            <nav class="bg-teal-700 pt-2 md:pt-1 px-1 py-2 mt-0 h-auto fixed w-full z-20 top-0">

                <div class="flex flex-wrap items-center">
                    <div class={`flex flex-shrink justify-center ${(page === 'login' || page === 'studentdb') ? 'md:justify-center md:w-full' : 'md:justify-start md:w-1/2'}  text-white content-center`}>
                        <span onClick={() => goHome()} className="cursor-pointer text-xl pl-2">{page === 'login' ? 'TestView' : ''}{(userData) ? (userData.user_type === 'user') ? 'Organization : ' + userData.organization_name : (userData.user_type === 'admin') ? 'TestView Admin' : 'TestView Super Admin' : ''}</span>
                    </div>

                    {/* <div class="flex flex-1 md:w-1/3 justify-center md:justify-start text-white px-2">
                        <span class="relative w-full">
                            <input type="search" placeholder="Search" class="w-full bg-gray-900 text-white transition border border-transparent focus:outline-none focus:border-gray-400 rounded py-3 px-2 pl-10 appearance-none leading-normal" />
                                <div class="absolute search-icon" style={{"top": "1rem", "left": ".8rem"}}>
                                    <svg class="fill-current pointer-events-none text-white w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                        <path d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"></path>
                                    </svg>
                                </div>
                        </span>
                    </div> */}
                    {page === "login" ? "" : <>
                        <div class="flex w-full pt-2 content-center justify-end md:w-1/2 md:justify-end">
                            <ul class="list-reset flex justify-between flex-1 md:flex-none items-center">
                                {/* <li class="flex-1 md:flex-none md:mr-3">
                                    <a class="inline-block py-2 px-4 text-white no-underline" href="#">Active</a>
                                </li>
                                <li class="flex-1 md:flex-none md:mr-3">
                                    <a class="inline-block text-gray-600 no-underline hover:text-gray-200 hover:text-underline py-2 px-4" href="#">link</a>
                                </li> */}
                                <li class="flex-1 md:flex-none md:mr-3">
                                    {usertype !== 'user' ? <>
                                        <div class="relative inline-block" onMouseLeave={hideDropdown}>
                                            <button onMouseEnter={showDropdown} class="drop-button text-white focus:outline-none"> <span class="pr-2"><i class="em em-robot_face"></i></span> Hi, {username} <svg class="h-3 fill-current inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg></button>
                                            <div id="myDropdown" className={`dropdownlist absolute bg-gray-800 text-white right-0 p-3 overflow-auto z-30 ${isDropdownVisible ? '' : 'invisible'}`}>
                                                {/* <input type="text" class="drop-search p-2 text-gray-600" placeholder="Search.." id="myInput" onkeyup="filterDD('myDropdown','myInput')" /> */}
                                                {/* <a href="#" class="p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block"><i class="fa fa-user fa-fw"></i> Profile</a>
                                                <a href="#" class="p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block"><i class="fa fa-cog fa-fw"></i> Settings</a>
                                                <div class="border border-gray-800"></div> */}
                                                <Link onClick={logout} to={``} class="p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block w-max"><i class="fas fa-sign-out-alt fa-fw"></i> Log Out</Link>
                                            </div>
                                        </div>
                                    </> : ""}
                                </li>
                            </ul>
                        </div>
                    </>}
                </div>

            </nav>
        </>
    )
}

export default Navbar